import Loading from "src/components/Loading";
import Sessions from "./Sessions";
import UploadFile from "./UploadFile";
import ScrubWarnings from "./ScrubWarnings";
import ScrubPaywall from "./ScrubPaywall";
import { useSignupAccess } from "src/hooks/useSignupAccess";
import { SHOW_PAYWALLS } from "src/constants/featureFlags";

const UploadList = () => {
  const access = useSignupAccess("dncscrub", SHOW_PAYWALLS);

  if (SHOW_PAYWALLS) {
    if (access.isPending) return <Loading />;
    if (access.data !== undefined && !access.data.hasAccess) {
      return <ScrubPaywall />;
    }
  }

  return (
    <>
      <UploadFile />
      <ScrubWarnings />
      <Sessions />
    </>
  );
};

export default UploadList;
